import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS } from 'actions/actionConstants'
import { FETCH_MERCHANDISE_BRANDS, FETCH_MERCHANDISE_BY_ID, FETCH_MERCHANDISE_CATEGORIES, FETCH_MERCHANDISE_HERO_PROMOS, FETCH_MERCHANDISE_LIST, FETCH_MERCHANDISE_TOP_BRANDS, FETCH_MERCHANDISE_TOP_CATEGORIES } from 'actions/apiActionConstants'
import { arrayToObject } from 'lib/array/arrayUtils'
import { apiReducerSwitch, createAppReducer } from 'lib/redux/reducerUtils'

export const initialMerchandiseState: App.MerchandiseState = {
  fetchingMerchandise: {},
  merchandiseErrors: {},
  merchandiseLists: {},
  fetchingMerchandiseLists: {},
  merchandiseListErrors: {},
  merchandise: {},
  merchandiseCategories: {},
  fetchingMerchandiseCategories: {},
  merchandiseCategoryErrors: {},
  merchandiseTopCategories: undefined,
  merchandiseHeroPromos: undefined,
  merchandiseTopBrands: undefined,
  merchandiseBrands: undefined,
}

const apiCalls = apiReducerSwitch<App.MerchandiseState>({
  [FETCH_MERCHANDISE_BRANDS]: {
    request: () => ({
      merchandiseBrands: {
        brands: {},
        fetching: true,
      },
    }),
    success: (state, action) => ({
      merchandiseBrands: {
        brands: arrayToObject(action.data, brand => brand.id),
        fetching: false,
      },
    }),

    failure: (_, action) => ({
      merchandiseBrands: {
        brands: {},
        fetching: false,
        error: action.error,
      },
    }),
  },
  [FETCH_MERCHANDISE_BY_ID]: {
    request: (state, action) => ({
      fetchingMerchandise: {
        ...state.fetchingMerchandise,
        [action.id]: true,
      },
    }),

    success: (state, action) => ({
      fetchingMerchandise: {
        ...state.fetchingMerchandise,
        [action.id]: false,
      },
      merchandise: {
        ...state.merchandise,
        [action.id]: action.data,
      },
    }),

    failure: (state, action) => ({
      fetchingMerchandise: {
        ...state.fetchingMerchandise,
        [action.id]: false,
      },
      merchandiseErrors: {
        ...state.merchandiseErrors,
        [action.id]: action.error,
      },
    }),
  },

  [FETCH_MERCHANDISE_LIST]: {
    request: (state, action) => ({
      fetchingMerchandiseLists: {
        ...state.fetchingMerchandiseLists,
        [action.key]: true,
      },
    }),

    success: (state, action) => ({
      fetchingMerchandiseLists: {
        ...state.fetchingMerchandiseLists,
        [action.key]: false,
      },
      merchandiseLists: {
        ...state.merchandiseLists,
        [action.key]: action.data,
      },
    }),

    failure: (state, action) => ({
      fetchingMerchandiseLists: {
        ...state.fetchingMerchandiseLists,
        [action.key]: false,
      },
      merchandiseListErrors: {
        ...state.merchandiseListErrors,
        [action.key]: action.error,
      },
    }),
  },

  [FETCH_MERCHANDISE_TOP_CATEGORIES]: {
    request: () => ({
      merchandiseTopCategories: {
        categoryIds: [],
        fetching: true,
      },
    }),

    success: (state, action) => ({
      merchandiseTopCategories: {
        categoryIds: action.data,
        fetching: false,
      },
    }),

    failure: (_, action) => ({
      merchandiseTopCategories: {
        categoryIds: [],
        fetching: false,
        error: action.error,
      },
    }),
  },

  [FETCH_MERCHANDISE_HERO_PROMOS]: {
    request: () => ({
      merchandiseHeroPromos: {
        heroPromos: [],
        fetching: true,
      },
    }),

    success: (state, action) => ({
      merchandiseHeroPromos: {
        heroPromos: action.data,
        fetching: false,
      },
    }),

    failure: (_, action) => ({
      merchandiseHeroPromos: {
        heroPromos: [],
        fetching: false,
        error: action.error,
      },
    }),
  },

  [FETCH_MERCHANDISE_CATEGORIES]: {
    request: (state, action) => ({
      fetchingMerchandiseCategories: {
        ...state.fetchingMerchandiseCategories,
        [action.parentId]: true,
      },
    }),

    success: (state, action) => ({
      fetchingMerchandiseCategories: {
        ...state.fetchingMerchandiseCategories,
        [action.parentId]: false,
      },
      merchandiseCategories: {
        ...state.merchandiseCategories,
        ...arrayToObject(action.data, (cat: App.MerchandiseCategory) => cat.id),
      },
    }),

    failure: (state, action) => ({
      fetchingMerchandiseCategories: {
        ...state.fetchingMerchandiseCategories,
        [action.parentId]: false,
      },
      merchandiseCategoryErrors: {
        ...state.merchandiseCategoryErrors,
        [action.parentId]: action.error,
      },
    }),
  },

  [FETCH_MERCHANDISE_TOP_BRANDS]: {
    request: () => ({
      merchandiseTopBrands: {
        brands: [],
        fetching: true,
      },
    }),

    success: (state, action) => ({
      merchandiseTopBrands: {
        brands: action.data,
        fetching: false,
      },
    }),

    failure: (_, action) => ({
      merchandiseTopBrands: {
        brands: [],
        fetching: false,
        error: action.error,
      },
    }),
  },
})

export default createAppReducer<App.MerchandiseState>(initialMerchandiseState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
})
